import { t } from '@lingui/core/macro';

import { useRevenueRanges } from '@/api/settings';
import {
  CategoryFilter,
  ComboboxPickerFilter,
  encodeFilterFieldName,
  FilterField,
  useFilterForm,
} from '@/components/filters';
import type { FilterOperatorMulti } from '@/components/InstantSearch';
import type { FilterComponentProps } from '@/providers/TableState';

type Props = FilterComponentProps & {
  mode?: 'multiple';
};

const RevenueRangeFilter = ({ name, label, infoPopover, compact, mode = 'multiple' }: Props) => {
  const form = useFilterForm();
  const { revRanges, isLoading, error } = useRevenueRanges({ includeBlanks: true });

  return (
    <form.AppField name={encodeFilterFieldName(name)}>
      {(field) => (
        <FilterField
          data-testid="revenue-range-filter"
          label={label}
          infoPopover={infoPopover}
          hideLabel={!compact}
        >
          {compact ? (
            <ComboboxPickerFilter
              value={field.state.value as FilterOperatorMulti}
              onChange={field.handleChange}
              mode={mode}
              singlePlaceholder={t`Select Revenue Range...`}
              multiplePlaceholder={t`Select Revenue Ranges...`}
              multipleLoadingPlaceholder={t`Loading Revenue Ranges...`}
              items={revRanges}
              isLoading={isLoading}
              error={error}
              notFoundContent={t`No revenue ranges were found...`}
            />
          ) : (
            <CategoryFilter
              value={field.state.value as FilterOperatorMulti}
              onChange={field.handleChange}
              selectionMode={mode}
              isLoading={isLoading}
              error={error}
              options={revRanges}
            />
          )}
        </FilterField>
      )}
    </form.AppField>
  );
};

export default RevenueRangeFilter;
